// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-wrapper-body[data-v-40020842]{left:0;border-right:1px solid #e0e0e0}.header[data-v-40020842]{margin:10px}.tooltip[data-v-40020842]{color:#000}.main-body[data-v-40020842]{width:402px}.hide .main-body[data-v-40020842]{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
